import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

const LOGO = "https://customer-assets.emergentagent.com/job_d4fda698-50f5-4ffb-9202-1cc296025403/artifacts/9jmcuyor_UrbanConnect_RGB_Logo.png";

export default function Login() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");

  async function submit(e) {
    e.preventDefault();
    setError("");
    setNotice("");
    setBusy(true);
    try {
      if (mode === "login") {
        await login(email, password);
        nav("/");
      } else {
        const res = await register(name, email, password);
        if (res.pending) {
          setNotice(res.message || "Account created. Awaiting administrator approval.");
          setMode("login");
          setPassword("");
        } else {
          nav("/");
        }
      }
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-paper flex flex-col">
      <div className="bg-navy h-2 w-full" />
      <div className="flex-1 flex items-center justify-center px-5 py-10">
        <div className="w-full max-w-md uc-fade">
          <img src={LOGO} alt="Urban Connection" className="h-16 mb-8" />
          <h1 className="font-head text-3xl font-bold text-navydark tracking-tight">
            Crash Inspection
          </h1>
          <p className="text-steel mt-1 mb-8">
            Fatal &amp; Serious Crash Initial Response tool
          </p>

          <div className="flex gap-2 mb-6 p-1 bg-white rounded-full border-2 border-line">
            {["login", "register"].map((m) => (
              <button
                key={m}
                data-testid={`tab-${m}`}
                onClick={() => {
                  setMode(m);
                  setError("");
                  setNotice("");
                }}
                className={`flex-1 h-11 rounded-full font-head font-semibold capitalize transition-colors ${
                  mode === m ? "bg-navy text-white" : "text-steel"
                }`}
              >
                {m === "login" ? "Sign in" : "Register"}
              </button>
            ))}
          </div>

          <form onSubmit={submit} className="space-y-5">
            {notice && (
              <div
                className="p-4 rounded-xl bg-success/10 border-2 border-success/30 text-success text-sm font-semibold"
                data-testid="auth-notice"
              >
                {notice}
              </div>
            )}
            {mode === "register" && (
              <p className="text-sm text-steel -mb-1">
                Registration is restricted to <span className="font-semibold text-navy">@urbanconnection.co.nz</span> emails. New accounts require administrator approval before first sign-in.
              </p>
            )}
            {mode === "register" && (
              <div>
                <label className="uc-label">Full name</label>
                <input
                  className="uc-input"
                  data-testid="name-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            )}
            <div>
              <label className="uc-label">Email</label>
              <input
                type="email"
                className="uc-input"
                data-testid="email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="uc-label">Password</label>
              <input
                type="password"
                className="uc-input"
                data-testid="password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && (
              <div className="text-danger text-sm font-semibold" data-testid="auth-error">
                {error}
              </div>
            )}
            <button
              type="submit"
              className="uc-btn uc-btn-primary w-full"
              data-testid="submit-auth-btn"
              disabled={busy}
            >
              {busy ? "Please wait…" : mode === "login" ? "Sign in" : "Create account"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
